/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerSyncQueryResponse, VistaControllerSyncPathParams, VistaControllerSync400, VistaControllerSync401, VistaControllerSync403, VistaControllerSync404 } from "../../models/changeOrdersController/VistaControllerSync";

function getVistaControllerSyncUrl(id: VistaControllerSyncPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/potential-change-orders/${id}/vista/sync` as const }  
  return res
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista/sync}
 */
export async function vistaControllerSync(id: VistaControllerSyncPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<VistaControllerSyncQueryResponse, ResponseErrorConfig<VistaControllerSync400 | VistaControllerSync401 | VistaControllerSync403 | VistaControllerSync404>, unknown>({ method : "GET", url : getVistaControllerSyncUrl(id).url.toString(), ... requestConfig })  
  return res.data
}